import { useContext, createContext, useMemo } from 'react';

import { useSettings as useSettingsService } from 'services/settings';

const SettingsContext = createContext(null);

export const SettingsContextProvider = ({ children }) => {
  const { data, isLoading, refetch } = useSettingsService();

  const pipedrive_pipelines = useMemo(() => {
    if (!data?.pipedrive_pipelines) {
      return [];
    }
    return data?.pipedrive_pipelines.filter((item) =>
      process.env.REACT_APP_STAGE === 'prod'
        ? item.name.indexOf('Development') === -1
        : item.name.indexOf('Development') !== -1
    );
  }, [data]);

  return (
    <SettingsContext.Provider
      value={{
        settings: {
          ...(data || {}),
          pipedrive_pipelines
        },
        isSettingsLoading: isLoading,
        reloadSettings: refetch
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export function useSettings() {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error('useSettings must be used within a SettingsContextProvider');
  }

  return context;
}
